import { Component } from '@angular/core';
import { COMPANY_PHONE_NUMBER } from 'src/app/constants/app.constants';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent {
  // These enquiryTypes will be used in future to select a ZenDesk ticket category
  // enquiryTypes = [
  //   'I need to change the keepership of a pet',
  //   'I need to change my address',
  //   'I am a breeder',
  //   'I have another query',
  //   'My pet has passed away',
  //   'My pet has gone missing or been stolen',
  // ];

  public COMPANY_PHONE_NUMBER = COMPANY_PHONE_NUMBER;

  constructor(
    public userService: UserService
  ) { }

}
